import {CommonModule} from "@angular/common";
import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MenuComponent} from '../menu/menu.component';
import {IMenu, IMenuItem} from 'src/app/core/models/menu.model';
import {MyButtonComponent} from 'src/app/shared/components/buttons/my-button/my-button.component';
import {RouterModule} from '@angular/router';
import { ElaborazioneService } from "src/app/modules/elaborazioni/elaborazione.service";

@Component({
  selector: 'app-vertical-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MenuComponent,
    MyButtonComponent
  ],
  templateUrl: './vertical-navbar.component.html',
  styleUrl: './vertical-navbar.component.css',
  host: {'class': 'flex bg-bluegray-50 justify-content-center'}, //border-right-1 surface-border
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalNavbarComponent {
  constructor(public readonly elaborazioneService: ElaborazioneService){}
  @Input() menu?: IMenu;
  @Input() shortcut1?: IMenuItem;
  @Input() shortcut2?: IMenuItem;
  @Input() shortcut3?: IMenuItem;
}
